/* eslint-disable */
import { useEffect, useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import axios from 'axios';
import dayjs from 'dayjs';
import moment from 'moment';
import { Button, Divider, Modal, CardContent, Stack, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { LoadingButton } from '@mui/lab';
import { getMaintenanceTasksById } from 'components/axios/maintenanceAxios';
import { getEquipmentAlertsById } from 'components/axios/equipmentAlertsAxios';
import { getEquipmentCategoriesById, getEquipmentCategoriesByQuery, getMasterEquipmentPartsById, getMasterEquipmentPartsByQuery } from 'components/axios/equipmentCategoryAxios';
import MainCard from 'components/MainCard';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import CustomDateTimePicker from 'components/date_picker/CustomDateTimePicker';
import CustomFormEnumSelect from 'components/select/CustomFormEnumSelect';
import CustomFormSelect from 'components/select/CustomFormSelect';
import { useEnumApi } from 'contexts/EnumApiContext';
import FileDownloadIcon from 'components/FileDownloadIcon';
import { orderString } from 'data/data';
import EquipmentPartListLayer from './EquipmentPartListLayer';
import CustomDatePicker from 'components/date_picker/CustomDatePicker';
import { useSelector } from 'react-redux';
import { ROLE } from 'data/data';
import Chip from '@mui/material/Chip';
import { customFileAxios } from 'components/axios/customAxios';

const MaintenanceRequestLayer = ({alertId,  setIsLoading:setParentIsLoading, type, isOpen=false}) => {
  const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode } = useEnumApi();
  const { t } = useTranslation();
  const { role } = useEnumApi();
  const { name } = useSelector(state => state.user);

  // modal 관련
  const { openModal } = useModals();
  let [alertMessage, setAlertMessage] = useState('');
  
  const handleAlertClick = () => {
      openModal(modals.alertModal, {
          onClose : () => {
          },
          message: alertMessage,
      });
  };
  
  const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
  const regexDateTime = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]) (0[0-9]|1[0-9]|2[0-3]):(0[1-9]|[0-5][0-9])$/);
  const numberRegEx = /^[0-9]*$/;

  const [open, setOpen] = useState(isOpen);
  const handleOpen = () => {setOpen(true); setIsLoading(false); };
  const handleClose = () => setOpen(false);

  const { control, register , handleSubmit 
      , setValue , watch, formState : { isDirty , errors } } = useForm({});
  
  // 상황보고 필드 값 감시
  const watchDate = watch("reportYmd");
  const watchReporter = watch("reportUser");
  
  const [equipmentAlert, setEquipmentAlert] = useState(null);
  const [maintenanceTask, setMaintenanceTask] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);

  const nextID = useRef(1);
  const [inputFiles, setInputFiles] = useState([]);

  const nextPartID = useRef(1);
  const [inputParts, setInputParts] = useState([]);

  const [mtStatuss, setMtStatuss] = useState([]);
  const [equipmentCategoryComponents, setEquipmentCategoryComponents] = useState(null);
  const [equipmentCategoryPositions, setEquipmentCategoryPositions] = useState(null);
  
  const [equipmentCategoryComponentId, setEquipmentCategoryComponentId] = useState(null);
  const [masterEquipmentParts, setMasterEquipmentParts] = useState(null);
  
  useEffect(()=>{
    if (alertId) {
      getMaintenanceTask();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[alertId, isLoading]);

  const getMaintenanceTask = () => {
    Promise.all([
      getEquipmentAlertsById(alertId).then((data)=>{  // 경고내역
        setEquipmentAlert(data);
        return data;
      })
    ]).then((res)=>{
      if (res) {
        if (res[0]) { // 경고내역
          if (res[0].equipment && res[0].equipment.equipmentCtgr) {
            Promise.all([
              getEquipmentCategoriesById(res[0].equipment.equipmentCtgr.id).then((data3) => {
                if (data3 && data3.positions) {
                  let positions = [];
                  data3.positions.map(function(item) {
                    positions.push({id:item, name:item});
                  })
                  orderString(positions,"id");
                  setEquipmentCategoryPositions(positions);
                }
                return data3;
              })
              ,
              getEquipmentCategoriesByQuery({"parent.id": res[0].equipment.equipmentCtgr.id, depth: 4, size : 100, sort : "name,asc"}).then((data4) => {
                if (data4 && data4._embedded) {
                  setEquipmentCategoryComponents(data4._embedded.equipmentCategories);
                }
                return data4;
              })
            ]).then((res2)=>{
              if (res[0].mntTask && res[0].mntTask.id) {
                getMaintenanceTasksById(res[0].mntTask.id).then((data)=>{ // 유지보수내역
                  return data;
                }).then((taskResult)=>{
                  if (taskResult) { // 유지보수내역
                    const task = taskResult;
                    if (task.status === 'O4_V') { // 완료
                      setMtStatuss(getEnumValueByEnumName("MaintenanceStatus").filter(item=> (item.code === 'O4_V')));
                    } else {
                      setMtStatuss(getEnumValueByEnumName("MaintenanceStatus").filter(item=>(item.code !== 'O1_R' && item.code !== 'O4_V')))
                    }
                    setMaintenanceTask(task);
                    
                    setValue("componentId", (task.equipmentCtgr && task.equipmentCtgr.id) || '');
                    setEquipmentCategoryComponentId((task.equipmentCtgr && task.equipmentCtgr.id) || '');
                    setValue("cost", task.cost);
                    setValue("mntSpType", task.mntSpType || '');
                    setValue("importantYn", task.importantYn || null);
                    setValue("position", task.position || '');
                    setValue("recordType", task.recordType || '');
                    setValue("remark", task.remark || null);
                    setValue("status", task.status || '');
                    setValue("troubleReason", task.troubleReason || null);
                    setValue("troubledAt", dayjs(task.troubledAt).format('YYYY-MM-DD HH:mm') || null);
                    setValue("type", task.type || '');
                    setValue("usedMethod", task.usedMethod || null);
                    setValue("worker", task.worker || name || null);
                    setValue("workingBgnAt", dayjs(task.workingBgnAt).format('YYYY-MM-DD HH:mm') || null);
                    setValue("workingEndAt", dayjs(task.workingEndAt).format('YYYY-MM-DD HH:mm') || null);

                    if (task.statusReport) {
                      setValue("reportUser",(task.statusReport && (task.statusReport.reportUser || null)));
                      setValue("reportYmd",(task.statusReport && (task.statusReport.reportYmd || null)));
                      if (task.statusReport.reportFiles) {
                        let inputFilesCopy = [];
                        nextID.current = 1;
                        for (var j=0;j<task.statusReport.reportFiles.length;j++) {
                            const input = {
                                id: nextID.current,
                                file: {},
                                rFile: task.statusReport.reportFiles[j],
                            };
                            inputFilesCopy = [...inputFilesCopy, input]
                            nextID.current += 1;
                        }
                        setInputFiles(inputFilesCopy);
                      }
                    } else {
                      setValue("reportYmd",null);
                    }
          
                    if (task.equipmentParts && task.equipmentParts.length > 0) {
                      let inputPartsCopy = [];
                      nextPartID.current = 1;
                      task.equipmentParts.map(function(partItem, index) {
                        const input = {
                          id: nextPartID.current,
                          part : {
                            id : partItem.id,
                            partId: partItem.masterEquipmentPart.id,
                            partLifeSpanTime : partItem.masterEquipmentPart.lifeSpanTime,
                            count: partItem.cnt,
                          }
                        };
          
                        inputPartsCopy = [...inputPartsCopy, input]
                        nextPartID.current += 1;
                      })
                      setInputParts(inputPartsCopy);
                    }
                  } else {
                    setMtStatuss(getEnumValueByEnumName("MaintenanceStatus").filter(item=>(item.code !== 'O1_R' && item.code !== 'O4_V')))
                  }
                })
              } else {
                setMtStatuss(getEnumValueByEnumName("MaintenanceStatus").filter(item=>(item.code !== 'O1_R' && item.code !== 'O4_V')))
              }
            });
          }
        }
      }
      setIsLoading(true);
    })
  }

  useEffect(()=>{
    if (equipmentCategoryComponentId) {
      getMasterEquipmentPartsByQuery({ "equipmentCtgr.id": equipmentCategoryComponentId, size:100 }).then((data)=>{
        if (data && data._embedded) {
          setMasterEquipmentParts(data._embedded.masterEquipmentParts);
        }
      })
    }
  },[equipmentCategoryComponentId]);

  function addInputFile(file) {
    const input = {
        id: nextID.current,
        file: {},
        rFile: file,
    };

    setInputFiles([...inputFiles, input]);
    nextID.current += 1;
  }

  // 삭제
  function deleteInputFile(index) { 
      setInputFiles(inputFiles.filter(item => item.id !== index));
  }

  function handleInputFileChange(e, index) {
      if (index > inputFiles.length) return;
      
      
      let inputFilesCopy = [...inputFiles];
      inputFilesCopy[index].file = e.target.files[0];
      inputFilesCopy[index].rFile = null;
      setInputFiles(inputFilesCopy);
  }

  function addParts() {
    const input = {
      id: nextPartID.current,
      part : {
        id : 0,
        partId: 0,
        partLifeSpanTime : 0,
        count: 0,
      }
    };

    setInputParts([...inputParts, input]);
    nextPartID.current += 1;
  }

  // 삭제
  function deleteInputPart(index) { 
    setInputParts(inputParts.filter(item => item.id !== index));
  }

  function handleInputPartChange(e, index) {
      if (index > inputParts.length) return;
      const mPartId = e.target.value;

      Promise.all([
        getMasterEquipmentPartsById(mPartId).then((res)=>{
          let inputPartsCopy = [...inputParts];
          inputPartsCopy[index].part.partId = mPartId;
          inputPartsCopy[index].part.partLifeSpanTime = res.lifeSpanTime;
          setInputParts(inputPartsCopy);
        })
      ]);
  }
  
  function handleInputPartCountChange(e, index) {
      if (index > inputParts.length) return;
      
      let inputPartsCopy = [...inputParts];
      inputPartsCopy[index].part.count = e.target.value;
      setInputParts(inputPartsCopy);
  }

  const hasAnyValue = watchDate || watchReporter || (inputFiles && inputFiles.length > 0);
  const onSubmit = (data,e) => {
    setFileLoading(true);

    if (data.troubledAt != null && data.troubledAt != '' && !regexDateTime.test(data.troubledAt)) {
      alertMessage = t('message.common.alert.breakdown.maintenance.datetime.input');
      setAlertMessage(alertMessage);
      handleAlertClick();
      setFileLoading(false);
      return;
    }

    if (data.workingBgnAt != null && data.workingBgnAt != '' && !regexDateTime.test(data.workingBgnAt)) {
      alertMessage = t('message.common.alert.work.start.datetime.input');
      setAlertMessage(alertMessage);
      handleAlertClick();
      setFileLoading(false);
      return;
    }

    if (data.workingEndAt != null && data.workingEndAt != '' && !regexDateTime.test(data.workingEndAt)) {
      alertMessage = t('message.common.alert.work.end.datetime.input');
      setAlertMessage(alertMessage);
      handleAlertClick();
      setFileLoading(false);
      return;
    }

    if (data.troubledAt >= data.workingEndAt) {
      alertMessage = t('message.common.alert.work.end.datetime.not.equal.breakdown.datetime');
      setAlertMessage(alertMessage);
      handleAlertClick();
      setFileLoading(false);
      return;
    }

    if (data.cost != null && data.cost != '' && !numberRegEx.test(data.cost)) {
      alertMessage = t('message.common.alert.cost.only.number.input');
      setAlertMessage(alertMessage);
      handleAlertClick();
      setFileLoading(false);
      return;
    }
      
    let dto = {
      equipment : {id: equipmentAlert.equipment.id},
      equipmentAlert : {id: alertId},
      equipmentCtgr : {id: data.componentId},
      cost : data.cost,
      mntSpType : data.mntSpType,
      importantYn : data.importantYn,
      position : data.position,
      recordType : data.recordType,
      remark : data.remark,
      status : data.status,
      troubleReason : data.troubleReason,
      troubledAt : (data.troubledAt?.$d != null ? moment(data.troubledAt.$d).format() : dayjs(data.troubledAt).format()),
      type : data.type,
      usedMethod : data.usedMethod,
      worker : data.worker,
      workingBgnAt : (data.workingBgnAt?.$d != null ? moment(data.workingBgnAt.$d).format() : dayjs(data.workingBgnAt).format()),
      workingEndAt : (data.workingEndAt?.$d != null ? moment(data.workingEndAt.$d).format() : dayjs(data.workingEndAt).format()),
    }

    let statusReport = {};
    if (data.reportUser || data.reportYmd) {
      statusReport = {
        "reportUser" : data.reportUser,
        "reportYmd" : data.reportYmd,
      }
    }
    dto.statusReport = statusReport;
    console.log(dto)

    let formData = new FormData();

    let fileCnt = 0;
    if(inputFiles) {
      for (var l=0;l<inputFiles.length;l++) {
          if (inputFiles[l].file && inputFiles[l].file.name) {
              formData.append("statusFiles", inputFiles[l].file);
              fileCnt++;
          }
      }
    }

    let equipmentParts = [];
    let isDuple = false;
    if(inputParts && inputParts.length > 0) {
      for (var m=0;m<inputParts.length;m++) {
          console.log(inputParts[m])
          if (inputParts[m].part.partId) {
            let dupleChk = inputParts.filter(item => item.part.partId === inputParts[m].part.partId);
            if (dupleChk.length > 1) {
              isDuple = true;
              break;
            } else {
              if (inputParts[m].part.id !== 0) {
                equipmentParts.push({
                  id:inputParts[m].part.id, 
                  cnt : inputParts[m].part.count
                })
              } else {
                equipmentParts.push({
                  lifeSpanTime:inputParts[m].part.partLifeSpanTime, 
                  masterEquipmentPart:{
                    id:inputParts[m].part.partId
                  }, 
                  position : data.position,
                  cnt : inputParts[m].part.count
                })
              }
            }
          }
      }
      dto.equipmentParts = equipmentParts;
    }

    if (isDuple) {
      alertMessage = t('message.common.alert.duplication.material.check.again');
      setAlertMessage(alertMessage);
      handleAlertClick();
      setFileLoading(false);
      return;
    }

    if (data.status === 'O3_C' && equipmentParts.length === 0) {
      alertMessage = t('message.common.alert.material.select.add');
      setAlertMessage(alertMessage);
      handleAlertClick();
      setFileLoading(false);
      return;
    }

    let rfileCnt = 0;
    if (inputFiles) {
        let rFiles = [];
        for (var a2=0;a2<inputFiles.length;a2++) {
            if (inputFiles[a2].rFile && inputFiles[a2].rFile.id) {
                rFiles.push({id : inputFiles[a2].rFile.id});
                rfileCnt++;
            }
        }
        if (rFiles.length > 0)
          statusReport.reportFiles = rFiles;
    }
    
    if (data.reportYmd || data.reportUser || (fileCnt+rfileCnt) > 0) {
      if (data.reportYmd === null || data.reportYmd === undefined) {
        alertMessage = t('message.common.alert.status.report.date.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }
      if (data.reportYmd != null && data.reportYmd != '' && !regexDate.test(data.reportYmd)) {
        alertMessage = t('message.common.alert.status.report.date.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }
      if (data.reportUser === null || data.reportUser === undefined) {
        alertMessage = t('message.common.alert.status.reporter.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }
      if ((fileCnt+rfileCnt) === 0) {
        alertMessage = t('message.common.alert.status.report.file.write');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }
    }
    
    if(maintenanceTask && (role === ROLE.SA.code || role === ROLE.WA.code)) {  // 수정
      if (dto.status === 'O1_R') {
        alertMessage = t('message.common.alert.work.status.select');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      if (maintenanceTask.statusReport && maintenanceTask.statusReport.id)
        statusReport.id = (maintenanceTask.statusReport && maintenanceTask.statusReport.id);

      if (maintenanceTask.status === 'O4_V') {//(확인) - 상태, 자재 수정 불가
        delete dto.equipmentParts;
      }
      if (maintenanceTask.status === 'O4_V') {//(확인) - 상태, 자재 수정 불가
        delete dto.status;
      }

      dto.id = maintenanceTask.id;

      console.log(dto);
      formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          try {
            const res = customFileAxios.patch(`/api/maintenanceTasks/${maintenanceTask.id}`, formData).then((res)=>{
                //console.log(res);
                alertMessage = t('message.common.alert.modify.done');
                setAlertMessage(alertMessage);
                handleAlertClick();
                setFileLoading(false);
                setParentIsLoading(false);
                handleClose();
                //navigate('../modify/'+res.data.id+window.location.search);
            }).catch((err)=>{
                console.log(err);
                setFileLoading(false);
                if (!err.response?.data?.message) {
                    alertMessage = err.message;
                    setAlertMessage(alertMessage);
                    handleAlertClick();
                } else if (err.response.data.message) {
                    alertMessage = err.response.data.message;
                    setAlertMessage(alertMessage);
                    handleAlertClick();
                }
            });
            // return res.data;
          } catch (error) {
              console.error("error :", error);
              throw error;
          }

          // axios({
          //   method: "patch",
          //   url: process.env.REACT_APP_API_URL+"/api/maintenanceTasks/"+maintenanceTask.id,
          //   data: formData,
          //   headers : {
          //       'Content-type' : 'multipart/form-data',
          //       accept : 'application/json,',
          //       'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
          //       'Accept-Language' : t('locale')
          //   }
          // }).then((res)=>{
          //     //console.log(res);
          //     alertMessage = t('message.common.alert.modify.done');
          //     setAlertMessage(alertMessage);
          //     handleAlertClick();
          //     setFileLoading(false);
          //     setParentIsLoading(false);
          //     handleClose();
          // }).catch((err)=>{
          //     console.log(err);
          //     setFileLoading(false);
          //     if (!err.response?.data?.message) {
          //         alertMessage = err.message;
          //         setAlertMessage(alertMessage);
          //         handleAlertClick();
          //     } else if (err.response.data.message) {
          //         alertMessage = err.response.data.message;
          //         setAlertMessage(alertMessage);
          //         handleAlertClick();
          //     }
          // });
        },
        onClose : () => {
            console.log('close');
            setFileLoading(false);
        },
        message: t('message.common.alert.modify.question'),
      });
    }
    
    if((type === undefined || type === null) && maintenanceTask == null) {  // 등록
      formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          try {
              const res = customFileAxios.post(`/api/maintenanceTasks`, formData).then((res)=>{
                  //console.log(res);
                  alertMessage = t('message.common.alert.write.done');
                  setAlertMessage(alertMessage);
                  handleAlertClick();
                  setFileLoading(false);
                  setParentIsLoading(false);
                  handleClose();
                  //navigate('../modify/'+res.data.id+window.location.search);
              }).catch((err)=>{
                  console.log(err);
                  setFileLoading(false);
                  if (!err.response?.data?.message) {
                      alertMessage = err.message;
                      setAlertMessage(alertMessage);
                      handleAlertClick();
                  } else if (err.response.data.message) {
                      alertMessage = err.response.data.message;
                      setAlertMessage(alertMessage);
                      handleAlertClick();
                  }
              });
              // return res.data;
          } catch (error) {
              console.error("error :", error);
              throw error;
          }

          // axios({
          //   method: "post",
          //   url: process.env.REACT_APP_API_URL+"/api/maintenanceTasks",
          //   data: formData,
          //   headers : {
          //       'Content-type' : 'multipart/form-data',
          //       accept : 'application/json,',
          //       'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
          //       'Accept-Language' : t('locale')
          //   }
          // }).then((res)=>{
          //     //console.log(res);
          //     alertMessage = t('message.common.alert.write.done');
          //     setAlertMessage(alertMessage);
          //     handleAlertClick();
          //     setFileLoading(false);
          //     setParentIsLoading(false);
          //     handleClose();
          //     //navigate('../modify/'+res.data.id+window.location.search);
          // }).catch((err)=>{
          //     console.log(err);
          //     setFileLoading(false);
          //     if (!err.response?.data?.message) {
          //         alertMessage = err.message;
          //         setAlertMessage(alertMessage);
          //         handleAlertClick();
          //     } else if (err.response.data.message) {
          //         alertMessage = err.response.data.message;
          //         setAlertMessage(alertMessage);
          //         handleAlertClick();
          //     }
          // });
        },
        onClose : () => {
            console.log('close');
            setFileLoading(false);
        },
        message: t('message.common.alert.write.question'),
      });
    }
  }

  if (equipmentAlert) {
    return (
      <>
        {((type && type === "modify" && maintenanceTask 
          ) 
          || (type === undefined || type === null)
          ) &&
        <Button variant="contained" onClick={handleOpen}>
          {(type && type==="modify") ? t('message.common.btn.management.maintenance'):t('message.common.title.maintenance')}
        </Button>
        }
  
        <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <MainCard modal darkTitle content={false}>
            <div style={{display:"flex", alignItems: "center", justifyContent: "space-between", margin: "5px 0 10px 0"}}>
              <div>
                <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/popbullet.png`} alt='' /></span>&nbsp;
                <Chip label={t('message.common.title.maintenance')} color="success" />
              </div>

              <div style={{textAlign:"right"}}>
                <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                  {t('message.common.btn.close')}
                </Button>
              </div>
            </div>

            <CardContent>
              <TableContainer>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width pop_table view_table">
                  <TableBody>
                    {/* <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.subwayline')}</TableCell>
                      <TableCell className="view_td">
                        {equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.station && equipmentAlert.equipment.station.workingPart
                        && equipmentAlert.equipment.station.workingPart.subwayLine && getEnumValueByEnumNameAndCode("SubwayLine", equipmentAlert.equipment.station.workingPart.subwayLine) && getEnumValueByEnumNameAndCode("SubwayLine", equipmentAlert.equipment.station.workingPart.subwayLine)[0].title}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.workingPart')}</TableCell>
                      <TableCell className="view_td">
                        {equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.station && equipmentAlert.equipment.station.workingPart && equipmentAlert.equipment.station.workingPart.name}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.station')}</TableCell>
                      <TableCell className="view_td">
                          {equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.station && equipmentAlert.equipment.station.name}
                      </TableCell>
                    </TableRow> */}
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level1')}</TableCell>
                      <TableCell className="view_td">
                        {equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.equipmentCtgr && equipmentAlert.equipment.equipmentCtgr.parent && equipmentAlert.equipment.equipmentCtgr.parent.parent && equipmentAlert.equipment.equipmentCtgr.parent.parent.name}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level2')}</TableCell>
                      <TableCell className="view_td">
                        {equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.equipmentCtgr && equipmentAlert.equipment.equipmentCtgr.parent && equipmentAlert.equipment.equipmentCtgr.parent.name}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level3')}</TableCell>
                      <TableCell className="view_td">
                        {equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.equipmentCtgr && equipmentAlert.equipment.equipmentCtgr.name}
                      </TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.name')}</TableCell>
                      <TableCell colSpan="3" className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.name}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.number')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.equipmentNo}</TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.alertedAt')}</TableCell>
                      <TableCell colSpan="3" className="view_td">{equipmentAlert && dayjs(equipmentAlert.latestAlertedAt).format("YYYY-MM-DD HH:mm")}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.alertType')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.alertType && getEnumValueByEnumNameAndCode("AlertType", equipmentAlert.alertType) && getEnumValueByEnumNameAndCode("AlertType", equipmentAlert.alertType)[0].title}</TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.alertCategory')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.alertCategory && getEnumValueByEnumNameAndCode("AlertCategory", equipmentAlert.alertCategory) && getEnumValueByEnumNameAndCode("AlertCategory", equipmentAlert.alertCategory)[0].title}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.alertDetail')}</TableCell>
                      <TableCell colSpan="3" className="view_td_left">{equipmentAlert && equipmentAlert.alertDtl}</TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.constantInspection.checkedAt')}</TableCell>
                      <TableCell colSpan="3" className="view_td">{equipmentAlert && dayjs(equipmentAlert.fieldChkedAt).format("YYYY-MM-DD HH:mm")}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.constantInspection.confirm.user')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.fieldChkUser}</TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.fllwActionType')}</TableCell>
                      <TableCell colSpan="5" className="view_td_left">
                        {equipmentAlert && getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType) && getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType)[0].title}
                      </TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.breakdown.maintenance')}<br />{t('message.common.subtitle.occurrence.datetime')} *</TableCell>
                      <TableCell className="view_td">
                        <Controller
                          control={control}
                          name="troubledAt"
                          render={({ field: { name, value, ...field }, ref, fieldState }) => (
                            <CustomDateTimePicker 
                              field={field} style={{width:"90%"}} ref={ref} name={name} value={value} register={register} 
                              fieldState={fieldState}
                              requiredMessage={t('message.common.error.text.breakdown.maintenance.datetime.input')}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.breakdown.maintenance')}<br />{t('message.common.subtitle.cause')} *</TableCell>
                      <TableCell className="view_td" colSpan={3}>
                        <><TextField style={{width:"97%"}} id="outlined-basic" 
                          aria-invalid={!isDirty ? undefined : errors.troubleReason ? "true" : "false"}
                          {...register("troubleReason", {
                              required : t('message.common.error.text.breakdown.maintenance.cause.input')
                          })} 
                          defaultValue={maintenanceTask && (maintenanceTask.troubleReason || '')}
                          sx={{ minWidth: '90%' }} />
                        {errors.troubleReason && <small role="alert"><br></br>{errors.troubleReason.message}</small>}
                        </>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.analysis.type')} *</TableCell>
                      <TableCell className="view_td">
                        <>
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.recordType ? "true" : "false"}
                          control={control}
                          name="recordType"
                          render={({ field: {name} }) => (
                          <CustomFormEnumSelect
                              style={{ minWidth: '90%' }}
                              label={t('message.common.subtitle.analysis.type')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.error.text.analysis.type.select')}
                              defaultValue={maintenanceTask && (maintenanceTask.recordType || '')}
                              list={getEnumValueByEnumName("MaintenanceRecordType")}
                          />
                          )}
                        />
                        {errors.recordType && <small role="alert"><br></br>{errors.recordType.message}</small>}
                        </>
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.provider.type')} *</TableCell>
                      <TableCell className="view_td">
                        <>
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.mntSpType ? "true" : "false"}
                          control={control}
                          name="mntSpType"
                          render={({ field: {name} }) => (
                          <CustomFormEnumSelect
                              style={{ minWidth: '90%' }}
                              label={t('message.common.subtitle.provider.type')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.error.text.provider.type.select')}
                              defaultValue={maintenanceTask && (maintenanceTask.mntSpType || '')}
                              list={getEnumValueByEnumName("MaintenanceProviderType")}
                          />
                          )}
                        />
                        {errors.mntSpType && <small role="alert"><br></br>{errors.mntSpType.message}</small>}
                        </>
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.main.management')}</TableCell>
                      <TableCell className="view_td">
                        <>
                        <input type="checkbox" id="importantYn" {...register("importantYn", {
                        })}  />&nbsp;&nbsp;<label htmlFor="importantYn" style={{cursor:"pointer", color:"#000"}}></label>
                        </>
                      </TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.work.start.datetime')} *</TableCell>
                      <TableCell className="view_td">
                        <Controller
                          control={control}
                          name="workingBgnAt"
                          render={({ field: { name, value, ...field }, ref, fieldState }) => (
                            <CustomDateTimePicker 
                              field={field} style={{width:"90%"}} ref={ref} name={name} value={value} register={register} 
                              fieldState={fieldState}
                              requiredMessage={t('message.common.error.text.work.start.datetime.input')}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.work.end.datetime')} *</TableCell>
                      <TableCell className="view_td">
                        <Controller
                          control={control}
                          name="workingEndAt"
                          render={({ field: { name, value, ...field }, ref, fieldState }) => (
                            <CustomDateTimePicker 
                              field={field} style={{width:"90%"}} ref={ref} name={name} value={value} register={register} 
                              fieldState={fieldState}
                              requiredMessage={t('message.common.error.text.work.end.datetime.input')}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.used.equipment')}</TableCell>
                      <TableCell className="view_td">
                        <>
                        <TextField style={{width:"90%"}} id="outlined-basic" 
                          {...register("usedMethod", {
                          })} 
                          defaultValue={''}
                          sx={{ minWidth: '90%' }} />
                        </>
                      </TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.worker')} *</TableCell>
                      <TableCell className="view_td">
                        <>
                        <TextField style={{width:"90%"}} id="outlined-basic" 
                          aria-invalid={!isDirty ? undefined : errors.worker ? "true" : "false"}
                          {...register("worker", {
                              required : t('message.common.error.text.worker.input')
                          })} 
                          key={'worker'}
                          defaultValue={name || ''}
                          sx={{ minWidth: '90%' }} />
                          {errors.worker && <small role="alert"><br></br>{errors.worker.message}</small>}
                        </>
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.work.status')} *</TableCell>
                      <TableCell className="view_td">
                        {maintenanceTask && ((maintenanceTask.status && (maintenanceTask.status === 'O4_V'))) ?
                        maintenanceTask.status && getEnumValueByEnumNameAndCode("MaintenanceStatus", maintenanceTask.status) && getEnumValueByEnumNameAndCode("MaintenanceStatus", maintenanceTask.status)[0].title 
                        :
                        <>
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.status ? "true" : "false"}
                          control={control}
                          name="status"
                          render={({ field: {name} }) => (
                          <CustomFormEnumSelect
                              style={{ minWidth: '90%' }}
                              label={t('message.common.subtitle.work.status')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.alert.work.status.select')}
                              defaultValue={maintenanceTask && (maintenanceTask.status || '')}
                              list={mtStatuss}
                          />
                          )}
                        />
                        {errors.status && <small role="alert"><br></br>{errors.status.message}</small>}
                        </>
                        }
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.actionType')} *</TableCell>
                      <TableCell className="view_td">
                        <>
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.type ? "true" : "false"}
                          control={control}
                          name="type"
                          render={({ field: {name} }) => (
                          <CustomFormEnumSelect
                              style={{ minWidth: '90%' }}
                              label={t('message.common.subtitle.actionType')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.error.text.actionType.select')}
                              defaultValue={maintenanceTask && (maintenanceTask.type || '')}
                              list={getEnumValueByEnumName("MaintenanceType")}
                          />
                          )}
                        />
                        {errors.type && <small role="alert"><br></br>{errors.type.message}</small>}
                        </>
                      </TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.work.detail')} *</TableCell>
                      <TableCell colSpan="5" className='view_td_left'>
                        <>
                        <TextField style={{width:"98%"}} id="outlined-basic" 
                            aria-invalid={!isDirty ? undefined : errors.remark ? "true" : "false"}
                            {...register("remark", {
                                required : t('message.common.error.text.work.detail.input')
                            })} 
                            multiline
                            rows={4}
                            sx={{ minWidth: '90%' }} />
                        {errors.remark && <small role="alert"><br></br>{errors.remark.message}</small>}
                        </>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.component')} *</TableCell>
                      <TableCell className="view_td">
                        {(maintenanceTask && ((maintenanceTask.status && (maintenanceTask.status === 'O4_V')) || (inputParts.find(part=>part.part.id !== 0) !== undefined))) ?
                        maintenanceTask.equipmentCtgr.name :
                        <>
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.componentId ? "true" : "false"}
                          control={control}
                          name="componentId"
                          render={({ field: {name} }) => (
                          <CustomFormSelect
                              style={{ minWidth: '90%' }}
                              label={t('message.common.subtitle.equipment.component')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.error.text.equipment.component.select')}
                              defaultValue={maintenanceTask && (maintenanceTask.equipmentCtgr && maintenanceTask.equipmentCtgr.id || '')}
                              disabled={(maintenanceTask && ((maintenanceTask.status && (maintenanceTask.status === 'O4_V')) || (inputParts.find(part=>part.part.id !== 0) !== undefined))) ? true:false}
                              onChange={(e)=>{
                                  setEquipmentCategoryComponentId(e.target.value);
                              }}
                              list={equipmentCategoryComponents}
                          />
                          )}
                        />
                        {errors.componentId && <small role="alert"><br></br>{errors.componentId.message}</small>}
                        </>
                        }
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.component.location')} *</TableCell>
                      <TableCell className="view_td">
                        {(maintenanceTask && ((maintenanceTask.status && (maintenanceTask.status === 'O4_V')) || (inputParts.find(part=>part.part.id !== 0) !== undefined))) ?
                        maintenanceTask.position :
                        <>
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.position ? "true" : "false"}
                          control={control}
                          name="position"
                          render={({ field: {name} }) => (
                          <CustomFormSelect
                              style={{ minWidth: '90%' }}
                              label={t('message.common.subtitle.component.location')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.error.text.component.location.select')}
                              defaultValue={maintenanceTask && (maintenanceTask.position || '')}
                              disabled={(maintenanceTask && ((maintenanceTask.status && (maintenanceTask.status === 'O4_V')) || (inputParts.find(part=>part.part.id !== 0) !== undefined))) ? true:false}
                              list={equipmentCategoryPositions}
                          />
                          )}
                        />
                        {errors.position && <small role="alert"><br></br>{errors.position.message}</small>}
                        </>
                        }
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.expense')}</TableCell>
                      <TableCell className="view_td">
                        <>
                        <TextField style={{width:"90%"}} id="outlined-basic" 
                          aria-invalid={!isDirty ? undefined : errors.cost ? "true" : "false"}
                          {...register("cost", {
                            pattern : {
                              value : numberRegEx,
                              message : t('message.common.error.text.number.only.input')
                            }
                          })} 
                          defaultValue={maintenanceTask?.cost}
                          sx={{ minWidth: '90%' }} />
                        {errors.cost && <small role="alert"><br></br>{errors.cost.message}</small>}
                        </>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell className="th">
                        {t('message.common.subtitle.input.material')}
                        {maintenanceTask && maintenanceTask.status && (maintenanceTask.status === 'O4_V') ? "" :
                        <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addParts}>+</AddCircleOutlineIcon>
                        }
                      </TableCell>
                      <TableCell colSpan={4} className='view_td_left'>
                        {maintenanceTask && maintenanceTask.status && (maintenanceTask.status === 'O4_V') ?
                          inputParts && inputParts.map(function(item, index) {
                          return (
                          <div style={{marginLeft:"10px"}} key={index}>
                            {masterEquipmentParts && masterEquipmentParts.filter(comp => comp.id === item.part.partId)[0].name}
                            , {t('message.common.subtitle.quantity')} : {item.part.count}
                          </div>
                          )})
                        :
                        <>
                        {inputParts && inputParts.map(function(item, index) {
                          return (
                        <div className="plus" key={index}>
                          <Controller
                            sx={{ m: 1, minWidth: 150 }}
                            control={control}
                            name="equipmentPartsId"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                key={"equipmentPartsId_"+item.id}
                                style={{ minWidth: 150 }}
                                label={t('message.common.subtitle.input.material')}
                                register={register}
                                name={name}
                                defaultValue={item.part.partId || ''}
                                onChange={(e)=>{
                                  handleInputPartChange(e, index);
                                }}
                                list={(item.part && item.part.partId && item.part.id !== 0) ? masterEquipmentParts && masterEquipmentParts.filter(partItem => partItem.id===item.part.partId) : masterEquipmentParts}
                            />
                            )}
                          />
                          <div style={{marginLeft:"10px"}}>{t('message.common.subtitle.quantity')}</div>
                          <TextField 
                            key={"equipmentPartsCount_"+item.id}
                            id="outlined-basic" sx={{ m: 1, width: 50 }}
                            defaultValue={item.part.count || null}
                            onChange={(e)=>{handleInputPartCountChange(e, index)}} 
                          />
                          { inputParts[index] ? (
                              <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteInputPart(item.id)}>-</RemoveCircleOutlineIcon>
                          ) : (
                          ''
                          )}
                        </div>
                          )
                        })}
                        </>
                        }
                      </TableCell>
                      <TableCell>
                        <EquipmentPartListLayer equipmentCtgrId={equipmentAlert.equipment.equipmentCtgr.id} />
                      </TableCell>
                    </TableRow>
        
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.status.report.date')}</TableCell>
                      <TableCell className='view_td_left'>
                        <div className="piker">
                          <Controller
                            control={control}
                            name="reportYmd"
                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                              <CustomDatePicker
                                field={field} ref={ref} name={name} value={value} register={register}
                                fieldState={fieldState}
                                hasAnyValue={hasAnyValue}
                                validateMessage={t('message.common.alert.status.report.date.input')}
                                />
                            )} />
                        </div>
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.status.reporter')}</TableCell>
                      <TableCell className="view_td">
                        <TextField id="outlined-basic" 
                          {...register("reportUser", {
                              validate: (value) =>
                              !hasAnyValue || value ? true : t('message.common.alert.status.reporter.input'),
                          })} 
                          defaultValue={''}
                          sx={{ minWidth: '90%' }}
                          style={{marginLeft:"7px"}} />
                          {errors.reportUser && <small role="alert"><br></br>{errors.reportUser.message}</small>}
                      </TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th">
                      {t('message.common.subtitle.status.report.file')}
                        <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addInputFile}>+</AddCircleOutlineIcon>
                      </TableCell>
                      <TableCell colSpan="5" className='view_td_left'>
                        {inputFiles && inputFiles.map(function(item, index) {
                          return (
                          <div key={index} style={{display:"flex"}}>
                              <input
                                  type="file"
                                  value={''}
                                  style={{width:"unset"}}
                                  onChange={e => {
                                    handleInputFileChange(e, index);
                                  }}
                              />
                              {(item.file && item.file.name) ? item.file.name : (item.rFile && item.rFile.id && <><FileDownloadIcon file={item.rFile} viewFileName={true}  /></>)}
                              { inputFiles[index] ? (
                                  <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteInputFile(item.id)}>-</RemoveCircleOutlineIcon>
                              ) : (
                              ''
                              )}
                          </div>
                          )
                          })}
                          {hasAnyValue && inputFiles.length === 0 && (
                            <small role="alert"><br></br>{t('message.common.alert.status.report.file.write')}</small>
                          )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                </form>
              </TableContainer>
            </CardContent>
            <Divider />
            <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
              {((type && type === "modify" && maintenanceTask && maintenanceTask.workingBgnAt) || (maintenanceTask === null || (maintenanceTask && !maintenanceTask.workingBgnAt))) &&
              <LoadingButton variant="contained" size="small" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}>
                {(type && type==="modify" && maintenanceTask && maintenanceTask.workingBgnAt) ? ((role === ROLE.SA.code || role === ROLE.WA.code) ? t('message.common.btn.modify') : "") : (maintenanceTask === null || (maintenanceTask && !maintenanceTask.workingBgnAt)) ? t('message.common.btn.write') : ""}
              </LoadingButton>
              }
              <Button variant="contained" color="error" size="small" onClick={handleClose}>
                {t('message.common.btn.cancel')}
              </Button>
            </Stack>
          </MainCard>
        </Modal>
      </>
    )
  }
}

export default MaintenanceRequestLayer;
